<template>
  <div v-loading="loading">
    <el-form
      ref="form"
      :model="form"
      label-position="top"
      hide-required-asterisk
    >
      <form-box :title="$t('hzmbG.title.application')">
        <div class="form_type1_box">
          <el-row :gutter="86">
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbG.label.mobile')" prop="mobile">
                <div class="m-mobile_row">
                  <el-select
                    v-model="verifyForm.mobileAreaCode"
                    :placeholder="$t('hzmbG.label.mobileAreaCode')"
                    disabled
                  >
                    <el-option
                      v-for="item in areas"
                      :key="item.value"
                      :value="item.value"
                      :label="item.text"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model.number="verifyForm.mobile"
                    disabled
                  ></el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </form-box>
      <form-box :title="$t('hzmbG.title.vehicle')">
        <template slot="afterTitle">
          <el-popover placement="right" width="500" trigger="click">
            <i slot="reference" class="el-icon-warning-outline warn-icon"></i>
            <div class="row">
              <div style="margin-right: 8px">
                <div>{{ $t("hzmbG.label.personal") }}</div>
                <a :href="hzmbGFirstPersonalSampleImg" target="_blank">
                  <img :src="hzmbGFirstPersonalSampleImg" width="100%" />
                </a>
              </div>
              <div style="margin-left: 8px">
                <div>{{ $t("hzmbG.label.company") }}</div>
                <a :href="hzmbGFirstCompanySampleImg" target="_blank">
                  <img :src="hzmbGFirstCompanySampleImg" width="100%" />
                </a>
              </div>
            </div>
          </el-popover>
        </template>
        <div class="form_type1_box">
          <el-row :gutter="86">
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbG.label.registrationNo')">
                <el-input
                  v-model="form.vehicle.hongKongRegistrationNo"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbG.label.identificationNo')"
                prop="vehicle.identificationNo"
              >
                <el-input
                  v-model="form.vehicle.identificationNo"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbG.label.registrationType')"
                prop="vehicle.registrationType"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                ]"
              >
                <el-select
                  v-model="form.vehicle.registrationType"
                  :placeholder="$t('hzmbG.message.registrationType')"
                  @change="onRegistrationTypeChange"
                >
                  <el-option
                    v-for="item in HKVEHICLEREGISTERTYPE"
                    :key="item"
                    :value="item"
                    :label="item | hkVehicleRegisterType"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbG.label.factory')"
                prop="vehicle.factory"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                ]"
              >
                <el-select
                  v-model="form.vehicle.factory"
                  :placeholder="$t('hzmbG.message.factory')"
                  filterable
                  @focus="selectFilterFocus = 'factory'"
                  @blur="selectFilterFocus = null"
                  @change="
                    (val) =>
                      onBaseChange(
                        val,
                        factoryNames,
                        'factoryNameCn',
                        'factoryNamePt'
                      )
                  "
                >
                  <template
                    v-if="selectFilterFocus === 'factory'"
                    slot="prefix"
                  >
                    <i class="el-icon-search"></i>
                  </template>
                  <el-option
                    v-for="(item, i) in factoryNames"
                    :key="i"
                    :value="item.codeKey"
                    :label="`${item.nameCn || ''}${
                      item.nameCn && item.namePt ? '-' : ''
                    }${item.namePt || ''}`"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbG.label.modelType')"
                prop="vehicle.modelType"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                ]"
              >
                <el-input
                  v-model="form.vehicle.modelType"
                  :placeholder="$t('hzmbG.message.modelType')"
                  maxlength="200"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbG.label.buildYear')"
                prop="vehicle.buildYear"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                ]"
              >
                <el-date-picker
                  v-model="form.vehicle.buildYear"
                  type="year"
                  value-format="yyyy"
                  :placeholder="$t('hzmbG.message.buildYear')"
                  :picker-options="buildYearPickerOption"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbG.label.firstRegisterDate')"
                prop="vehicle.firstRegisterDate"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                ]"
              >
                <el-date-picker
                  v-model="form.vehicle.firstRegisterDate"
                  type="date"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                  :picker-options="beforeToday"
                  :placeholder="$t('hzmbG.message.firstRegisterDate')"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbG.label.color')"
                prop="vehicle.color"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                ]"
              >
                <el-select
                  v-model="form.vehicle.color"
                  :placeholder="$t('hzmbG.message.color')"
                  filterable
                  @focus="selectFilterFocus = 'color'"
                  @blur="selectFilterFocus = null"
                  @change="
                    (val) =>
                      onBaseChange(val, colors, 'colorNameCn', 'colorNamePt')
                  "
                >
                  <template v-if="selectFilterFocus === 'color'" slot="prefix">
                    <i class="el-icon-search"></i>
                  </template>
                  <el-option
                    v-for="(item, i) in colors"
                    :key="i"
                    :value="item.codeKey"
                    :label="item[baseParameterLocale]"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="!isTowTruck" :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbG.label.driverSeat')"
                prop="vehicle.driverSeat"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                ]"
              >
                <el-select
                  v-model="form.vehicle.driverSeat"
                  :placeholder="$t('hzmbG.label.driverSeat')"
                >
                  <el-option
                    v-for="item in DRIVERSEAT"
                    :key="item"
                    :value="item"
                    :label="item | driverSeat"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="!isTowTruck" :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbG.label.passengerCount')"
                prop="vehicle.passengerCount"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                ]"
              >
                <el-input-number
                  v-model="form.vehicle.passengerCount"
                  :min="0"
                  :max="998"
                  :step="1"
                  step-strictly
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col v-if="!isTowTruck" :xs="24" :sm="12">
              <el-form-item>
                <div class="vehicle-size-row">
                  <el-form-item
                    v-for="i in 4"
                    :key="i"
                    :label="i === 1 ? $t('hzmbG.label.engineNo') : ''"
                    :prop="`vehicle.engineNo${i}`"
                    :rules="[
                      {
                        required: i === 1,
                        message: $t('message.formRuleMessage.notNull'),
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.vehicle[`engineNo${i}`]"
                      maxlength="60"
                      :placeholder="`${$t('hzmbG.message.engineNo', [i])}`"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                prop="vehicle.permitWeight"
                class="m-form-item-custom"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                  {
                    pattern: /^([1-9]\d*|0)(\.\d)?$/,
                    message: $t('hzmbG.message.permitWeightFloat'),
                  },
                  {
                    type: 'number',
                    max: 999.9,
                    message: $t('hzmbG.message.permitWeightMax'),
                  },
                ]"
              >
                <div class="el-form-item__label m-form-item__custom">
                  <span class="m-is-quired">{{
                    $t("hzmbG.label.permitWeight")
                  }}</span>
                  <el-popover
                    placement="bottom"
                    :title="$t('hzmbG.message.permitWeightTable.title')"
                    width="540"
                    trigger="click"
                    popper-class="m-popper-table"
                  >
                    <i
                      slot="reference"
                      class="el-icon-warning-outline warn-icon"
                    ></i>
                    <el-table
                      :data="[
                        {
                          type: $t('hzmbG.message.vehicleType1'),
                          two: '16 t',
                          three: '22 t',
                          four: '22 t',
                          more: '22 t',
                        },
                        {
                          type: $t('hzmbG.message.vehicleType2'),
                          two: '-',
                          three: '26 t',
                          four: '32 t',
                          more: '38 t',
                        },
                        {
                          type: $t('hzmbG.message.vehicleType3'),
                          two: '-',
                          three: '-',
                          four: '32 t',
                          more: '38 t',
                        },
                      ]"
                      class="m-popover-table"
                      border
                    >
                      <el-table-column
                        :label="$t('hzmbG.message.vehicleType')"
                        prop="type"
                        width="170px"
                      ></el-table-column>
                      <el-table-column
                        :label="$t('hzmbG.message.permitWeightTable.weight')"
                      >
                        <el-table-column
                          :label="$t('hzmbG.message.permitWeightTable.two')"
                          prop="two"
                        ></el-table-column>
                        <el-table-column
                          :label="$t('hzmbG.message.permitWeightTable.three')"
                          prop="three"
                        ></el-table-column>
                        <el-table-column
                          :label="$t('hzmbG.message.permitWeightTable.four')"
                          prop="four"
                        ></el-table-column>
                        <el-table-column
                          :label="
                            $t('hzmbG.message.permitWeightTable.fiveOrMore')
                          "
                          prop="more"
                        ></el-table-column>
                      </el-table-column>
                    </el-table>
                  </el-popover>
                </div>
                <!-- 可解决oninput数据双向绑定失效问题
                @blur="$set(data,'clickPoint' ,$event.target.value)" -->
                <el-input
                  type="number"
                  v-model.number="form.vehicle.permitWeight"
                  :placeholder="$t('hzmbG.message.permitWeight')"
                  oninput="if(value.length > 5) value=value.slice(0, 5)"
                >
                  <template slot="append">{{
                    $t("hzmbG.message.ton")
                  }}</template>
                </el-input>
                <!-- 備註：三軸或以上限重12噸 -->
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbG.label.licenseExpireDate')"
                prop="vehicle.licenseExpireDate"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                ]"
              >
                <el-date-picker
                  v-model="form.vehicle.licenseExpireDate"
                  type="date"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                  :picker-options="afterToday"
                  :placeholder="$t('hzmbG.message.licenseExpireDate')"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbG.label.mainlandRegistrationNo')">
                <div class="m-mobile_row">
                  <el-select v-model="form.vehicle.mainlandNoPre">
                    <el-option
                      v-for="(item, i) in ['粤']"
                      :key="i"
                      :value="item"
                      :label="item"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="form.vehicle.mainlandRegistrationNo"
                    maxlength="8"
                    :placeholder="$t('hzmbG.message.mainlandRegistrationNo')"
                    @input="
                      inputToUpperCase(
                        $event,
                        form.vehicle,
                        'mainlandRegistrationNo'
                      )
                    "
                  ></el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </form-box>
      <form-box :title="$t('hzmbG.title.owner')">
        <div class="form_type1_box">
          <el-row :gutter="86">
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbG.label.registerType')"
                prop="owner.registerType"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                ]"
              >
                <el-select
                  v-model="form.owner.registerType"
                  :placeholder="$t('hzmbG.message.registerType')"
                  @change="onRegisterTypeChange"
                >
                  <el-option
                    v-for="item in REGISTERTYPE"
                    :key="item"
                    :value="item"
                    :label="item | registerType"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              v-if="form.owner.registerType === 'PERSON'"
              :xs="24"
              :sm="24"
            >
              <el-form-item
                :label="$t('hzmbG.label.ownerNameEn')"
                prop="owner.nameEn"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                  {
                    pattern: /^[A-Za-z !@#$%^&*()_+=[\]{};:',.<>/\|-]*$/,
                    message: $t('hzmbG.message.nameEnChcek'),
                  },
                ]"
              >
                <el-input
                  v-model="form.owner.nameEn"
                  type="textarea"
                  maxlength="200"
                  :placeholder="$t('hzmbG.message.ownerNameEn')"
                  autosize
                  @input="inputToUpperCase($event, form.owner, 'nameEn')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col
              v-if="form.owner.registerType === 'PERSON'"
              :xs="24"
              :sm="12"
            >
              <el-form-item
                :label="$t('hzmbG.label.identityType')"
                prop="owner.identityType"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                ]"
              >
                <el-select
                  v-model="form.owner.identityType"
                  :placeholder="$t('hzmbG.message.identityType')"
                >
                  <el-option
                    v-for="(item, i) in identityTypes"
                    :key="i"
                    :value="item.codeKey"
                    :label="`${item.codeKey}-${item.codeCname}-${item.codePname}`"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              v-if="form.owner.registerType === 'PERSON'"
              :xs="24"
              :sm="12"
            >
              <el-form-item
                :label="$t('hzmbG.label.identityNo')"
                prop="owner.identityNo"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                  {
                    pattern: /^[A-Za-z0-9]+$/,
                    message: $t('hzmbG.message.identityNoCheck'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="form.owner.identityNo"
                  maxlength="20"
                  :placeholder="$t('hzmbG.message.identityNo')"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col
              v-if="form.owner.registerType === 'PERSON'"
              :xs="24"
              :sm="24"
            >
              <el-form-item
                :label="$t('hzmbG.label.address')"
                prop="owner.address1"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                ]"
              >
                <el-input
                  v-model="form.owner.address1"
                  type="textarea"
                  autosize
                  maxlength="200"
                  :placeholder="$t('hzmbG.message.address')"
                  @input="inputToUpperCase($event, form.owner, 'address1')"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="form.owner.address2"
                  type="textarea"
                  autosize
                  maxlength="200"
                  :placeholder="$t('hzmbG.message.address')"
                  @input="inputToUpperCase($event, form.owner, 'address2')"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="form.owner.address3"
                  type="textarea"
                  autosize
                  maxlength="200"
                  :placeholder="$t('hzmbG.message.address')"
                  @input="inputToUpperCase($event, form.owner, 'address3')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col
              v-if="form.owner.registerType === 'COMPANY'"
              :xs="24"
              :sm="24"
            >
              <el-form-item
                :label="$t('hzmbG.label.ownerCompanyNameEn')"
                prop="owner.nameEn"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                  {
                    pattern: /^[A-Za-z0-9 !@#$%^&*()_+=[\]{};:',.<>/\|-]*$/,
                    message: $t('hzmbG.message.company_nameEnChcek'),
                  },
                ]"
              >
                <el-input
                  v-model="form.owner.nameEn"
                  type="textarea"
                  maxlength="200"
                  :placeholder="$t('hzmbG.message.ownerCompanyNameEn')"
                  autosize
                  @input="inputToUpperCase($event, form.owner, 'nameEn')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col
              v-if="form.owner.registerType === 'COMPANY'"
              :xs="24"
              :sm="12"
            >
              <el-form-item
                :label="$t('hzmbG.label.companyIdentityType')"
                prop="owner.companyIdentityType"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                ]"
              >
                <el-select
                  v-model="form.owner.companyIdentityType"
                  :placeholder="$t('hzmbG.message.companyIdentityType')"
                >
                  <el-option
                    v-for="(item, i) in companyIdentityTypes"
                    :key="i"
                    :value="item.codeKey"
                    :label="`${item.codeKey}-${item.codeCname}-${item.codePname}`"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              v-if="form.owner.registerType === 'COMPANY'"
              :xs="24"
              :sm="12"
            >
              <el-form-item
                :label="$t('hzmbG.label.companyRegisterNo')"
                prop="owner.companyRegisterNo"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                  {
                    pattern: /^[A-Za-z0-9]+$/,
                    message: $t('hzmbG.message.identityNoCheck'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="form.owner.companyRegisterNo"
                  maxlength="50"
                  :placeholder="$t('hzmbG.message.companyRegisterNo')"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col
              v-if="form.owner.registerType === 'COMPANY'"
              :xs="24"
              :sm="24"
            >
              <el-form-item
                :label="$t('hzmbG.label.companyAddress')"
                prop="owner.address1"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                ]"
              >
                <el-input
                  v-model="form.owner.address1"
                  type="textarea"
                  autosize
                  maxlength="200"
                  :placeholder="$t('hzmbG.message.companyAddress')"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="form.owner.address2"
                  type="textarea"
                  autosize
                  maxlength="200"
                  :placeholder="$t('hzmbG.message.companyAddress')"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="form.owner.address3"
                  type="textarea"
                  autosize
                  maxlength="200"
                  :placeholder="$t('hzmbG.message.companyAddress')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbG.label.macauMobile')"
                prop="owner.macauMobile"
              >
                <div class="m-mobile_row">
                  <el-select
                    v-model="form.owner.mobileAreaCode"
                    :placeholder="$t('hzmbG.label.mobileAreaCode')"
                    disabled
                  >
                    <el-option
                      v-for="item in areas"
                      :key="item.value"
                      :value="item.value"
                      :label="item.text"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="form.owner.macauMobile"
                    :placeholder="$t('hzmbG.message.macauMobile')"
                    disabled
                  ></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbG.label.email')"
                prop="owner.email"
                :rules="[
                  {
                    required: true,
                    message: $t('message.formRuleMessage.notNull'),
                  },
                  {
                    type: 'email',
                    message: $t('message.formRuleMessage.email'),
                    trigger: ['blur'],
                  },
                ]"
              >
                <el-input
                  id="email"
                  v-model="form.owner.email"
                  maxlength="50"
                  :placeholder="$t('hzmbG.message.email')"
                  @focus="onEmailInput"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="owner.emailConfirm"
                :rules="[
                  { validator: confirmEmailCheck, trigger: 'blur' },
                  {
                    type: 'email',
                    message: $t('message.formRuleMessage.email'),
                    trigger: ['blur'],
                  },
                ]"
              >
                <el-input
                  id="emailConfirm"
                  v-model="form.owner.emailConfirm"
                  maxlength="50"
                  :placeholder="$t('hzmbG.message.email_confirm')"
                  @focus="onEmailConfirmInput"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </form-box>
      <form-box v-if="!isTowTruck" :title="$t('hzmbG.title.drivers')">
        <div v-for="(item, index) in form.drivers" :key="index">
          <FormCard
            :title="
              $t('hzmbG.title.driversIndex', [
                $t(`message.capitalLetter[${index + 1}]`),
              ])
            "
            :showClose="form.drivers.length > 1"
            @close="$delete(form.drivers, index)"
          >
            <div class="form_box">
              <el-row :gutter="86">
                <el-col :xs="24" :sm="24">
                  <el-form-item
                    :label="$t('hzmbG.label.driverNameEn')"
                    :prop="`drivers.${index}.nameEn`"
                    :rules="[
                      {
                        required: true,
                        message: $t('message.formRuleMessage.notNull'),
                      },
                      {
                        pattern: /^[A-Za-z !@#$%^&*()_+=[\]{};:',.<>/\|-]*$/,
                        message: $t('hzmbG.message.nameEnChcek'),
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.drivers[index].nameEn"
                      maxlength="200"
                      :placeholder="$t('hzmbG.message.driverNameEn')"
                      @input="
                        inputToUpperCase($event, form.drivers[index], 'nameEn')
                      "
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbG.label.identityType')"
                    :prop="`drivers.${index}.identityType`"
                    :rules="[
                      {
                        required: true,
                        message: $t('message.formRuleMessage.notNull'),
                      },
                    ]"
                  >
                    <el-select
                      v-model="form.drivers[index].identityType"
                      :placeholder="$t('hzmbG.message.identityType')"
                    >
                      <el-option
                        v-for="(item, i) in identityTypes"
                        :key="i"
                        :value="item.codeKey"
                        :label="`${item.codeKey}-${item.codeCname}-${item.codePname}`"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbG.label.identityNo')"
                    :prop="`drivers.${index}.identityNo`"
                    :rules="[
                      {
                        required: true,
                        message: $t('message.formRuleMessage.notNull'),
                      },
                      {
                        pattern: /^[A-Za-z0-9]+$/,
                        message: $t('hzmbG.message.identityNoCheck'),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.drivers[index].identityNo"
                      maxlength="17"
                      :placeholder="$t('hzmbG.message.identityNo')"
                    ></el-input>
                    <div style="color: #6c6c6c; line-height: 26px">
                      {{ $t("hzmbG.message.driversIdentityNo") }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbG.label.hongKongDrivingLicenseType')"
                    :prop="`drivers.${index}.hongKongDrivingLicenseType`"
                    :rules="[
                      {
                        required: true,
                        message: $t('message.formRuleMessage.notNull'),
                      },
                    ]"
                  >
                    <el-select
                      v-model="form.drivers[index].hongKongDrivingLicenseType"
                      :placeholder="
                        $t('hzmbG.message.hongKongDrivingLicenseType')
                      "
                      @change="
                        (val) =>
                          onDriversBaseChange(
                            val,
                            hongKongDrivingLicenseTypes,
                            'hongKongDrivingLicenseTypeNameCn',
                            'hongKongDrivingLicenseTypeNamePt',
                            index
                          )
                      "
                    >
                      <el-option
                        v-for="item in hongKongDrivingLicenseTypesFilter"
                        :key="item.codeKey"
                        :value="item.codeKey"
                        :label="`${item.nameCn || ''}${
                          item.nameCn && item.namePt ? '-' : ''
                        }${item.namePt || ''}`"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbG.label.hongKongDrivingLicenseNo')"
                    :prop="`drivers.${index}.hongKongDrivingLicenseNo`"
                    :rules="[
                      {
                        required: true,
                        message: $t('message.formRuleMessage.notNull'),
                      },
                      {
                        pattern: /^[a-zA-Z0-9\/]+$/,
                        message: $t(
                          'hzmbG.message.hongKongDrivingLicenseNoCheck'
                        ),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.drivers[index].hongKongDrivingLicenseNo"
                      maxlength="20"
                      :placeholder="
                        $t('hzmbG.message.hongKongDrivingLicenseNo')
                      "
                    ></el-input>
                  </el-form-item>
                </el-col>
                <!-- <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbG.label.mainlandDrivingFileNo')"
                    :prop="`drivers.${index}.mainlandDrivingFileNo`"
                    :rules="[
                      {
                        pattern: /^[A-Za-z0-9]+$/,
                        message: $t('hzmbG.message.identityNoCheck'),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.drivers[index].mainlandDrivingFileNo"
                      maxlength="20"
                      :placeholder="$t('hzmbG.message.mainlandDrivingFileNo')"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbG.label.mainlandDrivingLicenseNo')"
                    :prop="`drivers.${index}.mainlandDrivingLicenseNo`"
                    :rules="[
                      {
                        pattern: /^[A-Za-z0-9]+$/,
                        message: $t('hzmbG.message.identityNoCheck'),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.drivers[index].mainlandDrivingLicenseNo"
                      maxlength="20"
                      :placeholder="
                        $t('hzmbG.message.mainlandDrivingLicenseNo')
                      "
                    ></el-input>
                  </el-form-item>
                </el-col> -->
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbG.label.birthday')"
                    :prop="`drivers.${index}.birthday`"
                    :rules="[
                      {
                        required: true,
                        message: $t('message.formRuleMessage.notNull'),
                      },
                      { validator: olderThan18, trigger: 'change' },
                    ]"
                  >
                    <el-date-picker
                      v-model="form.drivers[index].birthday"
                      type="date"
                      format="dd/MM/yyyy"
                      value-format="yyyy-MM-dd"
                      :picker-options="beforeToday"
                      :placeholder="$t('hzmbG.message.birthday')"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbG.label.sex')"
                    :prop="`drivers.${index}.sex`"
                    :rules="[
                      {
                        required: true,
                        message: $t('message.formRuleMessage.notNull'),
                      },
                    ]"
                  >
                    <el-select
                      v-model="form.drivers[index].sex"
                      :placeholder="$t('hzmbG.message.sex')"
                    >
                      <el-option
                        v-for="(item, i) in sexs"
                        :key="i"
                        :value="item.codeKey"
                        :label="item[idTypeLocalce]"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbG.label.nationality')"
                    :prop="`drivers.${index}.nationality`"
                    :rules="[
                      {
                        required: true,
                        message: $t('message.formRuleMessage.notNull'),
                      },
                    ]"
                  >
                    <el-select
                      v-model="form.drivers[index].nationality"
                      :placeholder="$t('hzmbG.message.nationality')"
                    >
                      <el-option
                        v-for="(item, i) in nationalitys"
                        :key="i"
                        :value="item.codeKey"
                        :label="item[idTypeLocalce]"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbG.label.macauMobile')"
                    :prop="`drivers.${index}.mobile`"
                    :rules="[
                      {
                        required: true,
                        message: $t('message.formRuleMessage.notNull'),
                      },
                      {
                        pattern:
                          form.drivers[index].mobileAreaCode === '853'
                            ? /^[6]{1}[0-9]{7}$/
                            : /^[0-9]{8}$/,
                        message: $t('message.formRuleMessage.macauMobile'),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <div class="m-mobile_row">
                      <el-select
                        v-model="form.drivers[index].mobileAreaCode"
                        :placeholder="$t('hzmbG.label.mobileAreaCode')"
                      >
                        <el-option
                          v-for="item in areas.filter((e) =>
                            ['853', '852'].includes(e.value)
                          )"
                          :key="item.value"
                          :value="item.value"
                          :label="item.text"
                        ></el-option>
                      </el-select>
                      <el-input
                        v-model.number="form.drivers[index].mobile"
                        :placeholder="$t('hzmbG.message.macauMobile')"
                        maxlength="8"
                      ></el-input>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbG.label.email')"
                    :prop="`drivers.${index}.email`"
                    :rules="[
                      {
                        type: 'email',
                        message: $t('message.formRuleMessage.email'),
                        trigger: ['blur'],
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.drivers[index].email"
                      maxlength="50"
                      :placeholder="$t('hzmbG.message.email')"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24">
                  <el-form-item
                    :label="$t('hzmbG.label.address')"
                    :prop="`drivers.${index}.address1`"
                    :rules="[
                      {
                        required: true,
                        message: $t('message.formRuleMessage.notNull'),
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.drivers[index].address1"
                      type="textarea"
                      autosize
                      maxlength="200"
                      :placeholder="$t('hzmbG.message.address')"
                      @input="
                        inputToUpperCase(
                          $event,
                          form.drivers[index],
                          'address1'
                        )
                      "
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.drivers[index].address2"
                      type="textarea"
                      autosize
                      maxlength="200"
                      :placeholder="$t('hzmbG.message.address')"
                      @input="
                        inputToUpperCase(
                          $event,
                          form.drivers[index],
                          'address2'
                        )
                      "
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.drivers[index].address3"
                      type="textarea"
                      autosize
                      maxlength="200"
                      :placeholder="$t('hzmbG.message.address')"
                      @input="
                        inputToUpperCase(
                          $event,
                          form.drivers[index],
                          'address3'
                        )
                      "
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </FormCard>
        </div>
        <!-- 新增駕駛員按鈕 -->
        <div class="add_driver">
          <GradientBtn
            :disabled="form.drivers.length === 3"
            @click="form.drivers.push({ mobileAreaCode: '852' })"
            >{{
              $t("message.DataRegistration.formData.add_drivers")
            }}</GradientBtn
          >
        </div>
      </form-box>
    </el-form>
    <div class="next_btn">
      <p class="m-tempsave-tips">{{ $t("message.tempSave_tips") }}</p>
      <GradientBtn @click="onSubmit" :loading="submitLoading"
        >{{ $t("message.DataRegistration.formData.next") }}
      </GradientBtn>
    </div>
  </div>
</template>

<script>
import i18n from "../../../../../public/lang/index";
import FormBox from "../components/FormBox.vue";
import GradientBtn from "@/components/GradientBtn.vue";
import FormCard from "../components/FormCard.vue";
import HzmbGFirstApplicationAPI from "@/api/hzmb-gh/HzmbGFirstApplicationAPI";
import VssViewAPI from "@/api/hzmb-gh/VssViewAPI";
import BaseParameterAPI from "@/api/hzmb-gh/BaseParameterAPI";
import { REGISTERTYPE, DRIVERSEAT, HKVEHICLEREGISTERTYPE } from "@/enums";
import { registerType, driverSeat, hkVehicleRegisterType } from "@/filters";
import hzmbGFirstPersonalSampleImg from "@/assets/hzmbg-vehicle-personal-sample.png";
import hzmbGFirstCompanySampleImg from "@/assets/hzmbg-vehicle-company-sample.png";
export default {
  components: { FormBox, GradientBtn, FormCard },
  filters: { registerType, driverSeat, hkVehicleRegisterType },
  data() {
    return {
      serviceType: this.$route.meta.serviceType,
      applicationId: this.$route.params.applicationId,
      loading: false,
      form: {
        drivers: [
          {
            mobileAreaCode: "852",
          },
        ],
        vehicle: {},
        owner: {
          mobileAreaCode: "852",
        },
      },
      verifyForm: {},
      identityTypes: [],
      companyIdentityTypes: [],
      sexs: [],
      nationalitys: [],
      colors: [],
      hongKongDrivingLicenseTypes: [],
      factoryNames: [],
      timer: "",
      selectFilterFocus: false,
      hzmbGFirstPersonalSampleImg,
      hzmbGFirstCompanySampleImg,

      submitLoading: false,

      areas: [
        { value: "853", text: i18n.t("hzmbG.enum.areas.macau") },
        { value: "852", text: i18n.t("hzmbG.enum.areas.hongkong") },
        { value: "86", text: i18n.t("hzmbG.enum.areas.mainland") },
      ],
      REGISTERTYPE,
      DRIVERSEAT,
      HKVEHICLEREGISTERTYPE,

      beforeToday: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果沒有後面的-8.64e6就是不可以選擇今天
        },
      },
      afterToday: {
        disabledDate(time) {
          return time.getTime() < new Date().getTime() - 3600 * 1000 * 24;
        },
      },
      buildYearPickerOption: {
        disabledDate: (time) => {
          const date = new Date();
          const year = date.getFullYear();
          const timeYear = time.getFullYear();
          return timeYear > year;
        },
      },
    };
  },
  computed: {
    idTypeLocalce() {
      return (
        ["codeCname", "codePname", "codePname"][
          ["ZH_TW", "PT", "EN"].indexOf(this.$i18n.locale)
        ] || "codeMasterCname"
      );
    },
    baseParameterLocale() {
      return (
        ["nameCn", "namePt", "namePt"][
          ["ZH_TW", "PT", "EN"].indexOf(this.$i18n.locale)
        ] || "nameCn"
      );
    },
    // 是否為拖車類型
    isTowTruck() {
      const { registrationType } = this.form.vehicle;
      return registrationType && registrationType === "TOW_TRUCK";
    },
    // 駕駛執照類型過濾
    hongKongDrivingLicenseTypesFilter() {
      const { registrationType } = this.form.vehicle;
      const types = this.hongKongDrivingLicenseTypes;
      // codeKey：2(輕型貨車)、18(中型貨車)、19(重型貨車)、20(掛接車輛)
      switch (registrationType) {
        case "MEDIUM_TRUCK":
          return types.filter((e) => ["18", "19", "20"].includes(e.codeKey));
        case "HEAVY_TRUCK":
          return types.filter((e) => ["19", "20"].includes(e.codeKey));
        case "TRACTOR":
          return types.filter((e) => ["20"].includes(e.codeKey));
        default:
          return types;
      }
    },
  },
  methods: {
    olderThan18(rule, value, callback) {
      const birthdays = new Date(value) || value;
      let d = new Date();
      let age = null;
      if (birthdays) {
        age =
          d.getFullYear() -
          birthdays.getFullYear() -
          (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
            ? 1
            : 0);
      }
      if (value && age < 18) {
        callback(new Error(this.$t("message.formRuleMessage.olderThan18")));
      } else {
        callback();
      }
    },
    confirmEmailCheck(rule, value, callback) {
      const { email } = this.form.owner;
      if (!value && email) {
        callback(new Error(i18n.t("hzmbG.message.email_confirm")));
      } else if (email && value !== email) {
        callback(new Error(i18n.t("hzmbG.message.emial_confirm_tip")));
      } else {
        callback();
      }
    },
    async get() {
      try {
        this.loading = true;
        const id = this.applicationId;
        let form = {};
        if (id) {
          form = await HzmbGFirstApplicationAPI.getById(this.applicationId);
        } else {
          const { registrationNo, identificationNo } = this.verifyForm;
          form = await HzmbGFirstApplicationAPI.getApplication(
            registrationNo,
            identificationNo
          );
        }
        // 預設一名駕駛員
        if (form.drivers && form.drivers.length < 1) {
          form.drivers.push({ mobileAreaCode: "852" });
        }
        if (form.vehicle) {
          // int轉string
          if (form.vehicle.buildYear)
            form.vehicle.buildYear = String(form.vehicle.buildYear);
          if (form.vehicle.length)
            form.vehicle.length = String(form.vehicle.length);
          if (form.vehicle.weight)
            form.vehicle.weight = String(form.vehicle.weight);
          if (form.vehicle.height)
            form.vehicle.height = String(form.vehicle.height);
          // 內地車輛登記號碼，默認「粵」
          if (!form.vehicle.mainlandNoPre) form.vehicle.mainlandNoPre = "粤";
        }
        if (form.owner) {
          // 車主信息聯絡電話區號默認852
          if (!form.owner.mobileAreaCode) {
            form.owner.mobileAreaCode = "852";
          }
          // 無需再次確認電郵
          if (form.owner.email) {
            form.owner.emailConfirm = form.owner.email;
          }
        }
        this.$set(this, "form", form);
        this.$nextTick(() => {
          this.$refs["form"].clearValidate();
        });
      } catch (error) {
        if (error.code === "DUPLICATE_APPROVING_APPLICATION") {
          this.$alert(
            this.$t("message.ErrorMessage.DUPLICATE_APPROVING_APPLICATION")
          );
          this.$router.replace(`/hzmb-truck-hk`);
        } else {
          this.$error(error);
        }
      } finally {
        this.loading = false;
      }
    },
    async getBase() {
      try {
        this.identityTypes = await VssViewAPI.getHzmbGByType("PERSON");
        this.companyIdentityTypes = await VssViewAPI.getHzmbGByType("COMPANY");
        this.sexs = await VssViewAPI.getsexs();
        this.nationalitys = await VssViewAPI.getNationalitys();
        this.colors = await BaseParameterAPI.getBaseParameter("COLOR");
        this.hongKongDrivingLicenseTypes =
          await BaseParameterAPI.getBaseParameter("HK_DRIVING_LICENSE_TYPE");
        this.factoryNames = await BaseParameterAPI.getBaseParameter(
          "VEH_FACTORY_NAME"
        );
      } catch (error) {
        this.$error(error);
      }
    },
    onSubmit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.doSubmit();
        } else {
          this.$message({
            type: "error",
            message: this.$t("message.form_error"),
          });
        }
      });
    },
    async doSubmit() {
      try {
        this.submitLoading = true;
        const form = this.form;
        const { id } = await HzmbGFirstApplicationAPI.tempSave(form);
        this.$router.push(`/hzmb-g-first/upload/${id}`);
      } catch (error) {
        this.$error(error);
      } finally {
        this.submitLoading = false;
      }
    },
    onBaseChange(codeKey, base, cn, pt) {
      const data = base.find((e) => e.codeKey === codeKey);
      if (data) {
        const { nameCn, namePt } = data;
        this.form.vehicle[cn] = nameCn;
        this.form.vehicle[pt] = namePt;
      }
    },
    onDriversBaseChange(codeKey, base, cn, pt, index) {
      const data = base.find((e) => e.codeKey === codeKey);
      if (data) {
        const { nameCn, namePt } = data;
        this.form.drivers[index][cn] = nameCn;
        this.form.drivers[index][pt] = namePt;
      }
    },
    onRegisterTypeChange(val) {
      if (val === "PERSON") {
        this.$delete(this.form.owner, "nameCn");
        this.$delete(this.form.owner, "companyIdentityType");
        this.$delete(this.form.owner, "companyRegisterNo");
      }
      if (val === "COMPANY") {
        this.$delete(this.form.owner, "nameEn");
        this.$delete(this.form.owner, "identityType");
        this.$delete(this.form.owner, "identityNo");
      }
    },
    onaxleCountChange() {
      setTimeout(() => {
        this.$refs["form"].validateField("vehicle.permitWeight");
      }, 300);
    },
    // 拖車類型，部分欄位不用填寫
    onRegistrationTypeChange() {
      const { registrationType } = this.form.vehicle;
      this.$set(this.form.vehicle, "axleCount", null);
      if (registrationType && registrationType === "TOW_TRUCK") {
        this.$set(this.form, "vehicle", {
          ...this.form.vehicle,
          passengerCount: null,
          engineNo1: null,
          engineNo2: null,
          engineNo3: null,
          engineNo4: null,
        });
        this.$set(this.form, "drivers", []);
      } else {
        this.$set(this.form, "drivers", [{ mobileAreaCode: "852" }]);
      }
    },
    // 輸入字母轉大寫
    inputToUpperCase(val, data, name) {
      data[name] = val.toUpperCase();
    },
    // 電子郵件禁止複製
    onEmailInput() {
      let email = document.getElementById("email");
      email.oncopy = () => {
        console.log("觸發複製");
        return false;
      };
    },
    // 再次確認電子郵件欄位禁止粘貼
    onEmailConfirmInput() {
      let email = document.getElementById("emailConfirm");
      email.onpaste = () => {
        console.log("觸發粘貼");
        return false;
      };
    },
  },
  created() {
    this.verifyForm = JSON.parse(localStorage.getItem("verifyForm")) || {};
    this.get();
    this.getBase();
  },
};
</script>

<style lang="scss" scoped>
.m-mobile_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  .el-select {
    width: 200px;
    margin-right: 16px;
  }
}
.el-input-number__decrease,
.el-input-number__increase {
  height: 46px;
}
.el-input-number {
  line-height: 46px;
}
.m-form__items {
  .el-textarea {
    margin-bottom: 8px;
  }
}
.el-row {
  align-items: flex-start;
}
/deep/.el-form--label-top .el-form-item__label {
  padding: 0;
}
.vehicle-size-row {
  .el-form-item + .el-form-item {
    margin-top: 22px;
  }
}
.add_driver {
  margin-top: 24px;
  text-align: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.m-form-item__custom:after {
  content: "" !important;
}
.m-form-item__custom .m-is-quired:after {
  content: "*";
  color: #f56c6c;
  margin-left: 4px;
}
.warn-icon {
  font-size: 18px;
  line-height: 38px;
  margin-left: 6px;
  cursor: pointer;
}

.m-popover-table {
  /deep/table {
    width: 100% !important;
  }
  /deep/th {
    background: #5ba7ad !important;
    color: #fff;
    text-align: center;
    padding: 6px 0;
  }
  /deep/td {
    text-align: center;
  }
}

/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

/deep/input[type="number"] {
  -moz-appearance: textfield;
}
/deep/.el-input__prefix .el-icon-search {
  font-size: 18px;
  position: relative;
  top: 4px;
  left: 2px;
}
</style>
<style>
.m-popper-table {
  max-width: calc(100% - 31px);
}
</style>
